import Vue from 'vue'

import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

    strict: true,

    state: {

        user: {

            email: null as string | null,

            role: null as string | null

        },

        form: {

            referenceNumber: null as string | null

        },

        currentDate: null as string | null

    },

    mutations:{

        UPDATE_EMAIL(state, payload) {

            state.user.email = payload;

        },

        UPDATE_ROLE(state, payload) {

            state.user.role = payload;

        },

        UPDATE_REFERENCE_NUMBER(state, payload) {

            state.form.referenceNumber = payload;

        },

        UPDATE_CURRENT_DATE(state, payload) {

            state.currentDate = payload;

        },

    },

    actions:{

        async updateEmail({commit}, payload){

            commit('UPDATE_EMAIL', payload)

        },

        async updateRole({commit}, payload){

            commit('UPDATE_ROLE', payload)

        },

        async updateReferenceNumber({commit}, payload){

            commit('UPDATE_REFERENCE_NUMBER', payload)

        },

        async updateCurrentDate({commit}, payload){

            commit('UPDATE_CURRENT_DATE', payload)

        },

    }

})
